<template>
  <div class="page-sign-detail">
    <van-form>
      <van-field v-model="detailData.policyNo" border readonly name="保单号" label="保单号" />
      <van-field v-model="detailData.productName" readonly name="产品名称" label="产品名称" />
      <van-field v-model="detailData.userName" readonly name="投/被保人" label="投/被保人" />
      <van-field v-model="detailData.salesmanName" readonly name="业务员" label="业务员" />
      <van-field v-model="detailData.signTypeText" readonly name="客户签收方式" label="客户签收方式"> </van-field>
      <template v-if="detailData.signType == 1">
        <van-field v-model="detailData.sendName" readonly name="递交人员" label="递交人员" />
        <van-field v-model="detailData.signDate" readonly name="签收日期" label="签收日期" />
        <van-field v-model="detailData.signAddress" readonly name="地址" label="地址" />
      </template>
      <template v-if="detailData.signType == 2">
        <van-field v-model="detailData.signMailCompany" readonly name="快递公司" label="快递公司" />
        <van-field v-model="detailData.signMailOrderNo" readonly name="快递单号" label="快递单号" />
      </template>
      <div class="btn-box">
        <van-button block type="info" @click="edit">编辑</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      detailData: ''
    };
  },
  watch: {},
  computed: {},
  methods: {
    edit() {
      this.$router.push({
        path: '/apps/policys/paperPolicy/signDetailEdit',
        query: {
          id: this.$route.query.id,
          sign: this.$route.query.sign
        }
      });
    }
  },
  created() {
    this.detailData = JSON.parse(sessionStorage.getItem('paperSignDetail'));
    this.detailData.userName = `${this.detailData.policyerName}/${this.detailData.insuranceName}`;
    this.detailData.signTypeText = this.detailData.signType == 1 ? '当面递交' : '快递寄送';
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.page-sign-detail {
  min-height: 100vh;
  background-color: #fff;
}
.van-cell:not(:last-child)::after {
  display: block !important;
  border-bottom: 1px solid #ebedf0;
}
.btn-box {
  padding: 200px 30px 0;
}
</style>